import { noddiAsync, URLKeys } from 'noddi-async';
import { brands, BrandType } from 'noddi-types';
import { isLocal } from 'noddi-web';
import { useEffect } from 'react';
import { useSetBrand } from '../stores/BrandStore/brandStore';

/**
 * On localhost, fetches the brand for a given service department and sets it as the current brand.
 * In dev/prod environments, brand is determined by the URL domain so this is a no-op.
 */
export function useLocalBrandFromOrg({
  serviceDepartmentId,
  serviceOrganizationId
}: {
  serviceDepartmentId?: number;
  serviceOrganizationId?: number;
}) {
  const setBrand = useSetBrand();

  const { data: brand, error: _brandError } = noddiAsync.useGet({
    type: URLKeys.getBrandByOrg,
    input: { serviceDepartmentId, serviceOrganizationId },
    queryConfig: {
      enabled: isLocal && (!!serviceDepartmentId || !!serviceOrganizationId)
    }
  });

  useEffect(() => {
    if (!brand) {
      return;
    }

    const domain = brand.domain as BrandType;
    if (domain in brands) {
      setBrand(domain);
    }
  }, [brand, setBrand]);
}
